import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import ArticleList from '../views/ArticleList.vue'
import NewsCenter from '../views/NewsCenter.vue'
import ImageNews from '../views/ImageNews.vue'
import ArticleDetail from '../views/ArticleDetail.vue'
import DoctorList from '../views/DoctorList.vue'
import DoctorDetail from '../views/DoctorDetail.vue'
import DepartmentList from '../views/DepartmentList.vue'
import SpecialtyList from '../views/SpecialtyList.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import MaternalVideo from '../views/MaternalVideo.vue'
import Download from '../views/Download.vue'
import MedicalGuide from '../views/MedicalGuide.vue'
import Xmtjz from '../views/Xmtjz.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/articles',
      name: 'articleList',
      component: ArticleList
    },
    {
      path: '/news-center',
      name: 'newsCenter',
      component: NewsCenter
    },
    {
      path: '/image-news',
      name: 'imageNews',
      component: ImageNews
    },
    {
      path: '/article/:id',
      name: 'articleDetail',
      component: ArticleDetail
    },
    {
      path: '/doctors',
      name: 'doctorList',
      component: DoctorList
    },
    {
      path: '/doctor/:id',
      name: 'doctorDetail',
      component: DoctorDetail
    },
    {
      path: '/departments',
      name: 'departmentList',
      component: DepartmentList
    },
    {
      path: '/specialties',
      name: 'specialtyList',
      component: SpecialtyList
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/maternal-videos',
      name: 'maternalVideo',
      component: MaternalVideo
    },
    {
      path: '/downloads',
      name: 'download',
      component: Download
    },
    {
      path: '/medical-guide',
      name: 'medicalGuide',
      component: MedicalGuide
    },
    {
      path: '/xmtjz',
      name: 'xmtjz',
      component: Xmtjz
    }
  ]
})
